<template>
    <div class="invoice-card">
        <div v-for="(data, idx) in dataList" :key="`${idx}-card`" class="m-d-16">
            <SOSlotCard
                :id="`card-${data.idmasal_transaksi}`"
                :card-type="typeCard"
                :dropdown-menu="`card`"
            >
                <template v-slot:before_head>
                    <div>
                        <div class="notification expired" v-if="data.last_generate_status === 'failed'">
                            <label class="m-d-0">
                                <span> Gagal Dijalankan, {{ $moment(data.last_generate).format("DD MMMM YYYY") }} {{ data.last_generate_status_info }} </span>
                            </label>
                        </div>
                        <div class="notification success" v-if="data.last_generate_status === 'success'">
                            <label class="m-d-0">
                                <span> Berhasil Dijalankan, {{ $moment(data.last_generate).format("DD MMMM YYYY") }} </span>
                            </label>
                        </div>
                    </div>
                </template>
                <template v-slot:card_head>
                    <div class="d-flex-between-center mt-2">
                        <div class="">
                            <span v-if="searchKey" v-html="searchHighlight(data.idmasal_transaksi, searchKey)"> </span>
                            <span v-else>{{ data.customer.nama }}</span>
                        </div>
                        <div>
                            <SOIconBase view-box="0 0 24 24" width="24" height="24">
                                <template v-slot:icon>
                                    <MoreMenu2424 />
                                </template>
                            </SOIconBase>
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div class="c-body">
                        <p class="m-d-0 f-13">
                            <SOIconBase view-box="0 0 16 16" width="16" height="16">
                                <template v-slot:icon>
                                    <MoodHappy1616 />
                                </template>
                            </SOIconBase>
                            <span class="mr-2"></span>
                            <span>{{ data.customer.telp }}</span>
                        </p>
                        <p class="m-d-0 f-13">
                            <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00065 2.66634C5.05513 2.66634 2.66732 5.05416 2.66732 7.99967C2.66732 10.9452 5.05513 13.333 8.00065 13.333C10.9462 13.333 13.334 10.9452 13.334 7.99967C13.334 5.05416 10.9462 2.66634 8.00065 2.66634ZM1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967ZM8.00065 3.99967C8.36884 3.99967 8.66732 4.29815 8.66732 4.66634V7.72353L11.0007 8.99967C11.261 9.26002 11.261 9.68213 11.0007 9.94248C10.7403 10.2028 10.3182 10.2028 10.0578 9.94248L7.52925 8.47108C7.40422 8.34605 7.33398 8.17649 7.33398 7.99967V4.66634C7.33398 4.29815 7.63246 3.99967 8.00065 3.99967Z" fill="#C8D0DD"/>
                            </svg>
                            <span class="text-uppercase">{{ data.jenis_periode == 'weekly' ? 'Mingguan' : "Bulanan"}}</span>
                        </p>
                        <p class="m-d-0 f-14 f-c-blue">
                            <svg class="mr-2" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33398 2.46278C1.33398 2.11497 1.61594 1.83301 1.96376 1.83301H8.26151C8.42854 1.83301 8.58872 1.89936 8.70683 2.01746L14.1179 7.42855C14.4698 7.78255 14.6673 8.2614 14.6673 8.76053C14.6673 9.25966 14.4698 9.73852 14.1179 10.0925L13.6714 9.64861L14.1166 10.0938L9.60135 14.6091C9.60127 14.6092 9.60144 14.609 9.60135 14.6091C9.42594 14.7846 9.21741 14.9241 8.98816 15.0192C8.75879 15.1142 8.51294 15.1632 8.26466 15.1632C8.01637 15.1632 7.77052 15.1142 7.54116 15.0192C7.31202 14.9242 7.10383 14.785 6.92847 14.6096M6.92796 14.6091L1.5187 9.20611C1.40044 9.08798 1.33398 8.92768 1.33398 8.76053V2.46278M13.2251 9.20409C13.2252 9.20394 13.2249 9.20423 13.2251 9.20409C13.3421 9.08613 13.4078 8.9267 13.4078 8.76053C13.4078 8.59436 13.3421 8.43493 13.2251 8.31698C13.2249 8.31683 13.2252 8.31712 13.2251 8.31698L8.00065 3.09256H2.59353V8.49945L7.81909 13.7189C7.87758 13.7775 7.94704 13.8239 8.02349 13.8556C8.09994 13.8873 8.18189 13.9036 8.26466 13.9036C8.34742 13.9036 8.42937 13.8873 8.50582 13.8556C8.58228 13.8239 8.65173 13.7775 8.71022 13.7189L13.2251 9.20409Z" fill="#206CFF"/>
                            </svg>
                            <span class="f-c-blue f-semi">Selanjutnya, {{ $moment(data.next_generate).format("dddd DD MMMM YYYY") }}</span>
                        </p>
                    </div>
                </template>
                <template v-slot:menu_card>
                    <div class="over-hidden">
                        <p class="dropdown-item p-x-8 m-d-0" @click="goEdit(data.idcustomer)" v-if="validateAccess('schedule.update')">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.16601 3.33301H3.33268C2.89065 3.33301 2.46673 3.5086 2.15417 3.82116C1.84161 4.13372 1.66602 4.55765 1.66602 4.99967V16.6663C1.66602 17.1084 1.84161 17.5323 2.15417 17.8449C2.46673 18.1574 2.89065 18.333 3.33268 18.333H14.9993C15.4414 18.333 15.8653 18.1574 16.1779 17.8449C16.4904 17.5323 16.666 17.1084 16.666 16.6663V10.833" stroke="#206CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.416 2.0832C15.7475 1.75168 16.1972 1.56543 16.666 1.56543C17.1349 1.56543 17.5845 1.75168 17.916 2.0832C18.2475 2.41472 18.4338 2.86436 18.4338 3.3332C18.4338 3.80204 18.2475 4.25168 17.916 4.5832L9.99935 12.4999L6.66602 13.3332L7.49935 9.99986L15.416 2.0832Z" stroke="#206CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="m-l-4">Ubah</span>
                        </p>
                        <div class="separator-line" v-if="validateAccess('schedule.read')"></div>
                        <p class="dropdown-item p-x-8 m-d-0" v-if="validateAccess('schedule.read')" @click="goRiwayat(data)">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.83681 7.50182H6.84931C7.01507 7.50182 7.17404 7.43597 7.29125 7.31876C7.40846 7.20155 7.47431 7.04258 7.47431 6.87682C7.47431 6.71106 7.40846 6.55209 7.29125 6.43488C7.17404 6.31767 7.01507 6.25182 6.84931 6.25182H4.97431C5.85032 5.08435 7.10731 4.26029 8.52728 3.92255C9.94725 3.58481 11.4406 3.7547 12.7485 4.40275C14.0563 5.0508 15.0961 6.13614 15.6875 7.47055C16.2789 8.80495 16.3846 10.3043 15.9863 11.7084C15.588 13.1126 14.7108 14.3331 13.5069 15.1583C12.3029 15.9835 10.8481 16.3612 9.39481 16.2261C7.9415 16.0909 6.58132 15.4514 5.55015 14.4184C4.51899 13.3854 3.88188 12.0241 3.74931 10.5706C3.74536 10.4863 3.72439 10.4037 3.68767 10.3278C3.65094 10.2518 3.59923 10.1841 3.53563 10.1287C3.47204 10.0733 3.39789 10.0313 3.31764 10.0053C3.23739 9.9793 3.15271 9.96981 3.0687 9.97741C2.98469 9.98501 2.90308 10.0095 2.8288 10.0495C2.75452 10.0895 2.6891 10.1441 2.63649 10.21C2.58387 10.276 2.54514 10.3519 2.52264 10.4332C2.50014 10.5145 2.49433 10.5995 2.50556 10.6831C2.66276 12.4019 3.40797 14.0139 4.6155 15.2471C5.82302 16.4804 7.41895 17.2594 9.13407 17.4528C10.8492 17.6462 12.5785 17.2421 14.0303 16.3087C15.4822 15.3753 16.5676 13.9697 17.1036 12.329C17.6396 10.6884 17.5933 8.91308 16.9725 7.30259C16.3518 5.6921 15.1945 4.345 13.696 3.48853C12.1975 2.63207 10.4495 2.31865 8.74679 2.60116C7.04409 2.88367 5.49092 3.74481 4.34931 5.03932V3.75182C4.34931 3.58606 4.28346 3.42709 4.16625 3.30988C4.04904 3.19267 3.89007 3.12682 3.72431 3.12682C3.55855 3.12682 3.39958 3.19267 3.28237 3.30988C3.16516 3.42709 3.09931 3.58606 3.09931 3.75182V6.87682C3.09931 7.04258 3.16516 7.20155 3.28237 7.31876C3.39958 7.43597 3.55855 7.50182 3.72431 7.50182H3.83681ZM9.34931 6.25182C9.51507 6.25182 9.67405 6.31767 9.79125 6.43488C9.90847 6.55209 9.97431 6.71106 9.97431 6.87682V10.0018H11.8493C12.0151 10.0018 12.174 10.0677 12.2913 10.1849C12.4085 10.3021 12.4743 10.4611 12.4743 10.6268C12.4743 10.7926 12.4085 10.9516 12.2913 11.0688C12.174 11.186 12.0151 11.2518 11.8493 11.2518H9.34931C9.18355 11.2518 9.02458 11.186 8.90737 11.0688C8.79016 10.9516 8.72431 10.7926 8.72431 10.6268V6.87682C8.72431 6.71106 8.79016 6.55209 8.90737 6.43488C9.02458 6.31767 9.18355 6.25182 9.34931 6.25182Z" fill="#206CFF"/>
                            </svg>
                            <span class="m-l-4">Riwayat Dijalankan</span>
                        </p>
                        <div class="separator-line" v-if="validateAccess('list.read')"></div>
                        <p class="dropdown-item p-x-8 m-d-0" v-if="validateAccess('list.read')" @click="goInvoice(data)">
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <FileText2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">List Invoice</span>
                        </p>
                        <div class="separator-line" v-if="!isLunas(data) && data.status_pembatalan !== 2"></div>
                        <div class="separator-line" v-if="validateAccess('schedule.delete')"></div>
                        <p class="dropdown-item p-x-8 m-d-0" v-if="validateAccess('schedule.delete')" @click="goDeleteInvoice(data.idcustomer)">
                            <SOIconBase view-box="0 0 20 20" width="20" height="20">
                                <template v-slot:icon>
                                    <Trash2020 />
                                </template>
                            </SOIconBase>
                            <span class="m-l-4">Hapus</span>
                        </p>
                   </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import TandaseruLingkaran1212 from "@/so-components/global/icons/iconPacks/TandaseruLingkaran1212.vue";
import MoreMenu2424 from "@/so-components/global/icons/iconPacks/MoreMenu2424.vue";
import MoodHappy1616 from "@/so-components/global/icons/iconPacks/MoodHappy1616.vue";
import OutletOut1616 from "@/so-components/global/icons/iconPacks/OutletOut1616.vue";
import FileText2020 from "@/so-components/global/icons/iconPacks/FileText2020.vue";
import Trash2020 from "@/so-components/global/icons/iconPacks/Trash2020.vue";
import WhatsappIcon1414 from "@/so-components/global/icons/iconPacks/WhatsappIcon1414.vue";
import Uang2020 from "@/so-components/global/icons/iconPacks/Uang2020.vue";
import CloseX1212 from "@/so-components/global/icons/iconPacks/CloseX1212.vue";

export default {
    name: "cardPenjadwalanInvoice",
    props: {
        typeCard: {
            type: String,
            default: "shadow",
        },
        searchKey: {
            type: String || Number,
            default: "",
        },
        dataList: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            deleting: false,
        };
    },
    components: {
        SOSlotCard,
        SOIconBase,
        TandaseruLingkaran1212,
        MoreMenu2424,
        MoodHappy1616,
        OutletOut1616,
        FileText2020,
        Trash2020,
        WhatsappIcon1414,
        Uang2020,
        CloseX1212,
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filter: "getFilter",
            filterItem: "getFilterItem",
        }),
        isExpired() {
            return (data, moment) => {
                let currentDate = moment();
                let expiredDate = moment(data.jatuh_tempo);

                if (
                    expiredDate.diff(currentDate) < 0 &&
                    !this.isLunas(data) &&
                    data.status_pembatalan !== 1 &&
                    data.status_pembatalan !== 2
                )
                    return true;
                return false;
            };
        },
        isLunas() {
            return (data) => {
                return data.lunas === 1;
            };
        },
    },
    methods: {
        goInvoice(data) {
            this.$store.commit("filterGlobalModule/resetFilterItem");
            let filter = this.filterItem
            const konsumen = {
                id: data.idcustomer,
                label: data.customer.nama,
            }
            filter.konsumen.push(konsumen)
            this.$router.push({
                name: "invoice.list",
            });
        },
        goRiwayat(data) {
            this.$router.push({
                name: 'invoicePenjadwalan.riwayat',
                params: {
                    idcustomer: data.idcustomer
                }
            });
        },
        goEdit(id) {
            this.$router.push({
                name: 'invoicePenjadwalan.edit',
                params: {
                    id: id,
                }
            });
        },
        goDeleteInvoice(id) {
            this.$emit("deleteList", id);
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
